import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["list", "status"]
  static values = { url: String, itemType: String }

  connect() {
    this.sortable = Sortable.create(this.listTarget, {
      handle: "[data-sort-handle]",
      animation: 150,
      ghostClass: "opacity-30",
      dragClass: "shadow-lg",
      onEnd: this.onDragEnd.bind(this)
    })
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  async onDragEnd(event) {
    if (event.oldIndex === event.newIndex) return

    const items = this.listTarget.querySelectorAll("[data-sort-id]")
    const newOrder = Array.from(items).map(el => parseInt(el.dataset.sortId, 10))

    this.updateStatus("Saving...")

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content

      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        },
        body: JSON.stringify({
          item_type: this.itemTypeValue,
          new_order: newOrder
        })
      })

      if (response.ok) {
        // Renumber sort IDs for subsequent drags
        items.forEach((el, i) => { el.dataset.sortId = i })
        this.updateStatus("Saved")
      } else {
        const data = await response.json()
        this.revertOrder(event)
        this.updateStatus(`Error: ${data.error || "Failed"}`)
      }
    } catch (error) {
      console.error("Reorder failed:", error)
      this.revertOrder(event)
      this.updateStatus("Save failed")
    }
  }

  revertOrder(event) {
    const { oldIndex, newIndex } = event
    const parent = this.listTarget
    const children = Array.from(parent.children)
    const movedEl = children[newIndex]

    parent.removeChild(movedEl)

    if (oldIndex >= parent.children.length) {
      parent.appendChild(movedEl)
    } else {
      parent.insertBefore(movedEl, parent.children[oldIndex])
    }
  }

  updateStatus(text) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = text
    }
  }
}
